import { WhatIfScenariosPage } from '@/pages/what-if/scenarios'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/whatif/scenarios')({
	component: WhatIfScenariosPage,
})
